import axios from 'axios';
import { getServerUrl } from '../config';

class ServerHealthService {
  static async getMainServerHealth() {
    try {
      // Use centralized config for all environments
      const url = `${getServerUrl('proxy')}/health`;
        
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching main server health:', error);
      return {
        status: 'error',
        error: error.message,
        timestamp: new Date().toISOString()
      };
    }
  }

  static async getImageServerHealth() {
    try {
      // Use centralized config for all environments
      const url = `${getServerUrl('imageProcessing')}/health`;
        
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching image server health:', error);
      return {
        status: 'error',
        error: error.message,
        timestamp: new Date().toISOString()
      };
    }
  }

  static async getStripeServerHealth() {
    try {
      // Use centralized config for all environments
      const url = `${getServerUrl('stripe')}/health`;
        
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching stripe server health:', error);
      return {
        status: 'error',
        error: error.message,
        timestamp: new Date().toISOString()
      };
    }
  }

  static formatUptime(uptimeInSeconds) {
    if (!uptimeInSeconds) return 'N/A';
    
    const days = Math.floor(uptimeInSeconds / (24 * 60 * 60));
    const hours = Math.floor((uptimeInSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((uptimeInSeconds % (60 * 60)) / 60);
    const seconds = Math.floor(uptimeInSeconds % 60);

    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0) parts.push(`${seconds}s`);

    return parts.join(' ');
  }

  static formatMemory(bytes) {
    if (!bytes) return 'N/A';
    
    const units = ['B', 'KB', 'MB', 'GB'];
    let size = bytes;
    let unitIndex = 0;

    while (size >= 1024 && unitIndex < units.length - 1) {
      size /= 1024;
      unitIndex++;
    }

    return `${size.toFixed(2)} ${units[unitIndex]}`;
  }
}

export default ServerHealthService;
